import React, { useState, useEffect, useContext } from "react";
import { UserContext } from "../UserContext";
import { useNavigate } from "react-router-dom";
import Footer from "../Footer";
import AdminNav from "../Navbars/AdminNav";
import { toast } from "react-toastify";
import "./RedeemHistory.css";
import axiosInstance from "./axiosInstance";

function RedeemHistory() {
  const [redeemHistory, setRedeemHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState("All");

  const { isAdmin, setUserRole, setUserInfo, userInfo } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    fetchUserInfo();
    fetchRedeemHistory();
  }, []);

  const fetchUserInfo = async () => {
    try {
      const response = await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/user`, {
        credentials: "include",
      });
      const data = await response.json();
      setUserInfo(data);
      if (data?.usertype) {
        setUserRole(data.usertype);
      }
    } catch (error) {
      console.log("Error in fetchUserInfo:", error);
    }
  };

  const fetchRedeemHistory = () => {
    setLoading(true);
    axiosInstance.get("/getRedeemHistory")
      .then((response) => {
        setRedeemHistory(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching redeem history:", error);
        toast.error("Failed to load redeem history", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setLoading(false);
      });
  };

  const handleStatusFilter = (status) => {
    setFilterStatus(status);
  };

  const filteredHistory = filterStatus === "All" 
    ? redeemHistory 
    : redeemHistory.filter(item => item.status === filterStatus);

  const formatDate = (dateString) => {
    const options = { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const onLogout = () => {
    fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/logout`, {
      credentials: "include",
      method: "POST",
    })
      .then(() => {
        navigate("/");
      })
      .catch((error) => {
        console.error("Logout failed:", error);
      });
    setUserInfo(null);
    setUserRole("guest");
  };

  const username = userInfo?.username;

  return (
    <>
      {username && isAdmin && <AdminNav username={username} onLogout={onLogout} />}
      
      <div className="redeem-history-container">
        <h2 className="page-title">Redeem History</h2>
        
        <div className="filter-controls">
          <div className="status-filters">
            <button 
              className={filterStatus === "All" ? "active" : ""}
              onClick={() => handleStatusFilter("All")}
            >
              All
            </button>
            <button 
              className={filterStatus === "Delivered" ? "active" : ""}
              onClick={() => handleStatusFilter("Delivered")}
            >
              Delivered
            </button>
            <button 
              className={filterStatus === "In Process" ? "active" : ""}
              onClick={() => handleStatusFilter("In Process")}
            >
              In Process
            </button>
            <button 
              className={filterStatus === "Open" ? "active" : ""}
              onClick={() => handleStatusFilter("Open")}
            >
              Open
            </button>
          </div>
        </div>
        
        <div className="history-table-container">
          {loading ? (
            <div className="loading-spinner">Loading...</div>
          ) : (
            <table className="history-table">
              <thead>
                <tr>
                  <th>Gift Name</th>
                  <th>Student Name</th>
                  <th>Redeem Time</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {filteredHistory.length > 0 ? (
                  filteredHistory.map((item, index) => (
                    <tr key={`${item.gift_id}-${index}`}>
                      <td>{item.giftname}</td>
                      <td>{item.student_name}</td>
                      <td>{formatDate(item.redeemtime)}</td>
                      <td>
                        <span className={`status-badge ${item.status.replace(" ", "-").toLowerCase()}`}>
                          {item.status}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="no-data">No redeem history found</td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
      
      <Footer />
    </>
  );
}

export default RedeemHistory;